// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

// import $ from 'jquery';
let jqueryCheck;


if($('body').hasClass("sfPageEditor")){
  jqueryCheck = true;
} else {
  jqueryCheck = false;
}

jQuery.noConflict();

import 'slick-carousel';

import objectFitImages from 'object-fit-images';

import Banner from '../_modules/banner/banner';
import Email from '../_modules/email/email';
import Navigation from '../_modules/molecules/navigation/navigation';
import Header from '../_modules/header/header';
import Card from '../_modules/molecules/card/card';
import Filter from '../_modules/molecules/filter/filter';
import Form from '../_modules/molecules/form/form';

import Carousel from '../_modules/molecules/carousel/carousel';
import QuickFacts from '../_modules/quick-facts/quick-facts';
import CardListing from '../_modules/card-listing/card-listing';
import Text from '../_modules/text/text';
import Accordion from '../_modules/molecules/accordion/accordion';
import SearchBar from '../_modules/molecules/search-bar/search-bar';


import './clamp.js';
import './bootstrap.js';
import './jquery.nice-select.min.js';

import 'tween-lite';
import 'scroll-to-plugin';

import moment from 'moment';
import 'moment/locale/en-au';
import './jquery.matchHeight';
window.throttle = require('lodash.throttle');
window.moment = moment;



if(jqueryCheck) {
  window.jq14 = jQuery.noConflict(true);
} else {
  window.jq14 = jQuery;
}


(function ($) {

      window.$ = window.jQuery

      new Banner();
      new SearchBar();

      new Navigation();
      new Header();
      new Carousel();
      new QuickFacts();
      new Accordion();
      new Card();
      new Filter();
      new CardListing();
      new Form();
      new Text();
      new Email();

      objectFitImages('img.object-fit', {watchMQ: true});

}(jq14));

console.log("After: ", jQuery().jquery);
